import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { groupSchemaObject } from '../../Data'
import { validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import authService from '../../Common/services';
import MaterialTable, { MTableBody } from "material-table";
import { Grid } from '@material-ui/core';
import tokenService from "../../../Common/tokenDecoder";
import { Checkbox } from "@material-ui/core";
import InputLabel from '@material-ui/core/InputLabel';
import { trackPromise } from "react-promise-tracker";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';

const screenCode = 'FACTORYITEMAPPROVAL';

export function FactoryItemApprovalDetailListing(props) {

    const useStyles = makeStyles((theme) => ({
        root: {
            '& > *': {
                margin: theme.spacing(1),
                width: '25ch',
            },
        },
    }));
    const classes = useStyles();
    const { data, edit, searchForm } = props.location
    const [title, setTitle] = useState("Factory Item Approval Detail")
    const [buttonName, setButtonName] = useState("Save")
    const [isChanged, setIsChanged] = useState(0)
    const [isViewButton, setIsViewButton] = useState(true);
    const [collectionPoint, setCollectionPoint] = useState();
    const [factoriesData, setFactoriesData] = useState();
    const [groups, setGroups] = useState();
    const [result, setResult] = useState([]);
    const [group, setGroup] = useState({
        cardNumber: "",
        collectionPointID: "",
        collectionPointName: "",
        createdDate: "",
        orderNumber: ""
    });
    const [search, setSearchForm] = useState({
        collectionPointID: 0,
        groupID: 0,
        operationEntityID: 0
    });
    const [unitPrice, setUnitPrice] = useState({
        data: []
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [cardActivateFiltering, setCardActivateFiltering] = useState([]);
    const [saveData, setSaveData] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const selectAll = () => {
        setCheckAll(!checkAll);
    };

    useEffect(() => {
        trackPromise(setCardActivateData());

        setSaveData([]);
    }, [result]);

    async function setCardActivateData() {
        await setCardActivateFiltering(result);
    }

    const schema = Joi.object(groupSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        if (search.groupID != 0) {
            trackPromise(
                getOperationEntitiesForDropdown()
            )
        }
    }, [search.groupID]);

    useEffect(() => {
        trackPromise(
            CollectionPointsByOperationEntity()
        )
    }, [search.operationEntityID]);

    useEffect(() => {
        getListingData();
    }, [search]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYITEMAPPROVALDETAIL');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        if (edit) {
            setTitle("Factory Item Approval Detail");
            setGroup(data);
            setSearchForm(searchForm);

        }
        trackPromise(
            setGroupDropDownData()
        )
    }
    async function getListingData() {
        const result = await services.getFactoryItemApprovalDetailData(group.collectionPointID, group.orderNumber);
        setResult(result);
    }
    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [group]);

    function handleChange(e) {
        const target = e.target

        const value = target.name === 'isActive' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, groupSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...search,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function handleApprove(e) {
        e.preventDefault()

        const response = await services.FactoryItemApprovalStatusUpdate(saveData)
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)

    }
    async function handleReject(e) {
        e.preventDefault()

        const response = await services.FactoryItemRejectStatusUpdate(saveData)
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)

    }

    async function setGroupDropDownData() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(search.groupID);
        setFactoriesData(opEntities);
    }

    async function CollectionPointsByOperationEntity() {
        let filteredData = await services.getCollectionPointByOperationEntityId(search.groupID, search.operationEntityID);
        setCollectionPoint(filteredData)
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/factoryItemApproval' })
            }, 1500);
        }
    }

    function clearState() {
        setGroup({
            ...group,
            groupCode: '',
            groupName: '',
            isActive: true
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function handleClick(data) {
        let cardData = {
            factoryItemRequestID: parseInt(data.factoryItemRequestID),
            approvedQuantity: parseInt(data.approvedQuantity),
            totalPrice: parseFloat(data.totalPrice),
            reason: (data.reason),
        };

        let dataRecords = [...saveData];

        var isEnable = dataRecords.find((p) => p.factoryItemRequestID == data.factoryItemRequestID);
        if (isEnable === undefined) {
            dataRecords.push(cardData);
        } else {
            var index = dataRecords.indexOf(isEnable);
            dataRecords.splice(index, 1);
        }

        setSaveData(dataRecords);
        setIsViewButton(false);
    }

    function handleClickAll(e) {
        var cardDataCopy = [...saveData];

        if (e.target.checked) {
            cardActivateFiltering.forEach(x => {
                let cardData = {
                    factoryItemRequestID: parseInt(x.factoryItemRequestID),
                    approvedQuantity: parseInt(x.approvedQuantity),
                    totalPrice: parseFloat(x.totalPrice),
                    reason: (x.reason),
                };

                var isEnable = cardDataCopy.find((p) => p.factoryItemRequestID == x.factoryItemRequestID);
                if (isEnable === undefined) {
                    cardDataCopy.push(cardData);
                }
            });
            setSaveData(cardDataCopy);

        } else {
            var emptyArray = [];
            setSaveData(emptyArray);
        }
        setIsViewButton(false);
    }
    function renderDropDown(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items;
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/factoryItemApproval"
                        />
                        <form>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="groupID">Group</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={true}
                                            name="groupID"
                                            value={search.groupID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Group Name--</MenuItem>
                                            {renderDropDown(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={true}
                                            name="operationEntityID"
                                            value={search.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {renderDropDown(factoriesData)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection Point</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            disabled={true}
                                            name="collectionPointID"
                                            value={search.collectionPointID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem key="0" value="0">--Select Collection Point--</MenuItem>
                                            {renderDropDown(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Card No"
                                            name="cardNo"
                                            id="cardNo"
                                            value={group.cardNumber}
                                            type="text"
                                            disabled={true}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["cardNo"] && <span id="errbranchCode" className="text text-danger">{errors["cardNo"]}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Order No"
                                            name="orderNumber"
                                            id="orderNumber"
                                            value={group.orderNumber}
                                            type="text"
                                            disabled={true}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["orderNumber"] && <span id="errbranchCode" className="text text-danger">{errors["orderNumber"]}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Request Date"
                                            name="requestDate"
                                            id="requestDate"
                                            value={group.createdDate}
                                            type="text"
                                            disabled={true}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["requestDate"] && <span id="errbranchCode" className="text text-danger">{errors["requestDate"]}</span>}
                                    </div>
                                </div>
                                <br />
                            </div>
                            <Grid item md={12} xs={12}>
                                <MaterialTable
                                    columns={[
                                        {
                                            title: 'Request ID', field: 'factoryItemRequestID',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never'
                                        },
                                        {
                                            title: 'Item Name', field: 'factoryItemName',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never'
                                        },
                                        {
                                            title: 'Item Code', field: 'factoryItemCode',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never'
                                        },
                                        {
                                            title: 'Requested Quantity', field: 'requestedQuantity',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never'
                                        },
                                        {
                                            title: 'Approved Quantity', field: 'approvedQuantity',
                                            headerStyle: { fontWeight: "bold" },
                                        },
                                        {
                                            title: 'Unit Price(LKR)', field: 'unitPrice',
                                            headerStyle: { fontWeight: "bold" },
                                        },
                                        {
                                            title: 'Total Price(LKR)', field: 'totalPrice',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never'
                                        },
                                        {
                                            title: 'Reason', field: 'reason',
                                            headerStyle: { fontWeight: "bold" },
                                            
                                        },
                                        
                                        {
                                            title: (
                                                <label>
                                                    <Checkbox
                                                        color="primary"
                                                        onClick={(e) => handleClickAll(e)}
                                                        onChange={selectAll}
                                                        checked={cardActivateFiltering.length != 0 && saveData.length == cardActivateFiltering.length}
                                                    ></Checkbox>
                                                    Select All
                                                </label>
                                            ),
                                            editable: 'never',
                                            sorting: false,
                                            field: "select",
                                            type: "boolean",
                                            render: (data) => (
                                                <Checkbox
                                                    color="primary"
                                                    onClick={() => handleClick(data)}
                                                    checked={!(saveData.find((x) => x.factoryItemRequestID == data.factoryItemRequestID) == undefined)}
                                                ></Checkbox>
                                            ),
                                        },
                                    ]}
                                    data={result}
                                    options={{
                                        exportAllData: true,
                                        showTitle: false,
                                        headerStyle: { textAlign: "left", height: '1%' },
                                        cellStyle: { textAlign: "left" },
                                        columnResizable: false,
                                        pageSize: 10
                                    }}
                                    cellEditable={{
                                        onCellEditApproved: (newValue, oldValue, rowData, columnDef) => {
                                            return new Promise((resolve, reject) => {
                                                const clonedData = [...result]

                                                if (columnDef.field == "approvedQuantity") {
                                                    if (newValue > (clonedData[rowData.tableData.id]['requestedQuantity'])) {
                                                        clonedData[rowData.tableData.id][columnDef.field] = clonedData[rowData.tableData.id]['requestedQuantity']
                                                        clonedData[rowData.tableData.id]['totalPrice'] = newValue * clonedData[rowData.tableData.id]['unitPrice']
                                                    }
                                                    else {
                                                        clonedData[rowData.tableData.id][columnDef.field] = newValue
                                                        clonedData[rowData.tableData.id]['totalPrice'] = newValue * clonedData[rowData.tableData.id]['unitPrice']
                                                    }

                                                }
                                                if (columnDef.field == "unitPrice") {
                                                    clonedData[rowData.tableData.id][columnDef.field] = newValue
                                                    clonedData[rowData.tableData.id]['totalPrice'] = newValue * clonedData[rowData.tableData.id]['approvedQuantity']
                                                }
                                                if (columnDef.field == "reason") {
                                                    clonedData[rowData.tableData.id][columnDef.field] = newValue
                                                   }
                                                clonedData.forEach(x => {
                                                    x.totalPrice = parseFloat(x.totalPrice).toFixed(2);
                                                })
                                                setResult(clonedData)
                                                setTimeout(resolve, 600);
                                            });
                                        }
                                    }}
                                />
                            </Grid>
                            <div className="card-footer">
                                <input
                                    type="submit"
                                    value="approve"
                                    className="btn btn-primary"
                                    onClick={handleApprove}
                                    disabled={isViewButton}
                                />
                                <input
                                    type="submit"
                                    value="Reject"
                                    className="btn btn-warning pull-right"
                                    onClick={handleReject}
                                    disabled={isViewButton}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}